import { AgGridVue } from 'ag-grid-vue'
import { mapState } from 'vuex'
import { instance, errorService } from '@/services/api'
import {
  projectlockedRow,
  strikeProjectAnalysisCalculations,
  updateGridRecord,
  addGridRecord,
} from '@/services/grid'
import _ from 'lodash'
import {
  calculateGridHeight,
  showNotification,
  evaluateQantity,
  convertCalculationForTemplateAnalysisSheet,
} from '@/services/calculate'
import { dropdownAPIs, projectAPIs } from '@/services/authConstantsV1'
import {
  socketEvents,
  replaceKeys,
  validateNumber,
  tableName,
} from '@/services/config'
import { formatValue } from '@/services/convert'
import TakeoffComponent from '@/components/DynamicComponents/Admin/MasterData/Project/Takeoff'
import ContractComponent from '@/components/DynamicComponents/Admin/MasterData/Project/Contract'
import CategoryCodeComponent from '@/components/DynamicComponents/Admin/MasterData/Project/CategoryCode'
import InputEditor from '@/components/DynamicComponents/Renderers/inputEditor'
import CheckboxRender from '@/components/DynamicComponents/Renderers/checkboxRender'
import SelectEditor from '@/components/DynamicComponents/Renderers/selectEditorDynamic'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import QuantityPerRenderer from '@/components/DynamicComponents/Renderers/quantityPerRenderer'
import AutoCompleteRenders from '@/components/DynamicComponents/Renderers/autoCompleteRenders'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import LockRenderes from '@/components/DynamicComponents/Renderers/lockRenderer'
import CalculationEditor from '@/components/DynamicComponents/Renderers/calculationEditor'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import NumberRender from '@/components/DynamicComponents/Renderers/numberRenderer'
import TakeoffSelectEditor from '@/components/DynamicComponents/Renderers/takeoffSelectEditor'
import TextEditor from '@/components/DynamicComponents/Renderers/textEditor'
import DropdownEditor from '@/components/DynamicComponents/Renderers/dropdownEditor'
import FactorEditor from '@/components/DynamicComponents/Renderers/factorEditor'
import exportTemplates from '@/components/DynamicComponents/Projects/Export'

export default {
  props: [
    'child',
    'projectData',
    'screenIndentifier',
    'dropdownData',
    'projectModule',
    'type',
    'assetList',
    'columnSettings',
    'activeKey',
  ],
  components: {
    'ag-grid-vue': AgGridVue,
    'add-category-code': CategoryCodeComponent,
    'add-contract': ContractComponent,
    'add-takeoff': TakeoffComponent,
    'export-sheet': exportTemplates,
  },
  data() {
    return {
      dropdownInfo: this.dropdownData,
      assetsData: [],
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: false,
        rowSelection: 'multiple',
        rowDragManaged: true,
        animateRows: true,
        defaultColDef: {
          sortable: true,
          resizable: true,
          editable: true,
          suppressMovable: true,
          wrapText: true,
          menuTabs: ['filterMenuTab'],
        },
      },
      assetName: undefined,
      assetId: undefined,
      columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '440px',
      data: [],
      tableState: null,
      enableDeleteClone: false,
      isAddTakeoff: false,
      loader: false,
      selectedRowKeys: [],
      visible: false,
      isAddContract: false,
      isAddCategory: false,
      sortedData: [],
      newlyAddedRecord: undefined,
      colKey: 'takeoff',
      selectUnlockRowKeys: [],
      isCalculationError: false,
      calculationData: this.projectData,
      title: 'Loading data...',
      postSort: null,
      isUpdate: false,
      isBlurCalled: true,
      takeoffDetails: null,
      dragIndex: null,
      exportClicked: false,
      url: projectAPIs.project.asset.analysisSheet.export(
        this.$route.params.id,
      ),
      rowIndex: undefined,
      sideBar: null,
      isArchive: false,
    }
  },
  computed: mapState(['assets']),
  watch: {
    activeKey() {
      if (this.activeKey === '1') {
        // this.reconcileSheet()
      }
    },
  },
  beforeMount() {
    this.isArchive = _.get(this.projectData, 'isArchive', false)
    this.loaderConfig()
    this.postSort = rowNodes => {
      this.sortedData = []
      for (let i = 0; i < rowNodes.length; i++) {
        if (rowNodes[i].data.categoryCode) {
          rowNodes[i].data.categoryCode = Number(rowNodes[i].data.categoryCode)
        }
        this.sortedData.push(rowNodes[i].data)
      }
      this.data = [...this.sortedData]
    }
  },
  mounted() {
    this.getAnalysisData()
    this.getAssetsDetails()
    // this.reconcileSheet()
    this.$root.$off('saveAnalysisData')
    this.$root.$on('saveAnalysisData', this.onUpdateTakeoff)
    this.child.$off('addNewRecord')
    this.child.$on('addNewRecord', this.addNewRecord)
    this.$root.$off('deleteRecord')
    this.$root.$on('deleteRecord', this.deleteRecord)
    this.child.$off('cloneTakeOff')
    this.child.$on('cloneTakeOff', this.cloneTakeOff)
    this.$root.$off('cloneTakeOff')
    this.$root.$on('cloneTakeOff', this.cloneTakeOff)
    this.child.$off('deleteTakeOff')
    this.child.$on('deleteTakeOff', this.deleteTakeOff)
    this.$socketHub.$off('message-received')
    this.$socketHub.$on('message-received', this.messageRecieved)
    window.addEventListener('resize', this.getWindowSize)
    this.$root.$off('unlockRow')
    this.$root.$on('unlockRow', this.unlockRow)
    this.$root.$off('gridSizeChange')
    this.$root.$on('gridSizeChange', this.getWindowSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
    this.$root.$off('showDrawer')
  },
  methods: {
    loaderConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        inputCellEditor: InputEditor,
        selectEditor: SelectEditor,
        costPriceCellRenderer: CurrencyRenderer,
        checkboxCellRender: CheckboxRender,
        autocomplete: AutoCompleteRenders,
        quantityPerCellRenderer: QuantityPerRenderer,
        lockShellRenderes: LockRenderes,
        inputNumberEditor: InputNumberEditor,
        customFilter: CustomFilter,
        toolTipRenderer: ToolTipRenderer,
        numberRender: NumberRender,
        calculationEditor: CalculationEditor,
        takeoffSelectEditor: TakeoffSelectEditor,
        textEditor: TextEditor,
        dropdownEditor: DropdownEditor,
        factorEditor: FactorEditor,
      }
      this.sideBar = {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressColumnSelectAll: false,
              suppressColumnExpandAll: true,
            },
          },
        ],
        defaultToolPanel: 'columns',
      }
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          hide: true,
          menuTabs: [],
          suppressColumnsToolPanel: true,
        },
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          pinned: 'left',
          menuTabs: [],
          suppressColumnsToolPanel: true,
        },
        {
          headerName: '',
          field: 'isLocked',
          headerTooltip: 'Locked',
          cellStyle: params => projectlockedRow(params, 'isLocked'),
          headerClass: 'header-center',
          width: 30,
          editable: false,
          cellRenderer: 'lockShellRenderes',
          cellRendererParams: {
            type: 'AnalysisSheet',
            dataType: 'int',
            isArchive: this.isArchive,
          },
          suppressSizeToFit: true,
          resizable: false,
          floatingFilter: false,
          hide: true,
          sortable: false,
          menuTabs: [],
          suppressColumnsToolPanel: true,
        },
        {
          headerName: 'ID',
          headerTooltip: 'ID',
          valueGetter: params => {
            return params.data.sequence
          },
          headerClass: 'analysis-header-center',
          cellStyle: params => projectlockedRow(params, 'sequence'),
          // cellStyle: { textAlign: 'left' },
          width: 50,
          wrapText: false,
          editable: false,
          suppressSizeToFit: true,
          resizable: true,
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
        },
        {
          headerName: 'Asset Number',
          field: 'assetNumber',
          sort: 'asc',
          filter: 'customFilter',
          headerTooltip: 'Asset Number',
          width: 70,
          cellStyle: params => projectlockedRow(params, 'assetNumber'),
          wrapText: false,
          editable: false,
          suppressSizeToFit: true,
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { field: 'assetNumber' },
          headerClass: 'analysis-header',
        },
        {
          headerName: 'Description',
          field: 'assetDescription',
          headerTooltip: 'Description',
          headerClass: 'analysis-header-left',
          cellStyle: params =>
            projectlockedRow(params, 'assetDescription', 'left'),
          width: 150,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          resizable: true,
          hide: !this.projectModule,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { field: 'assetDescription' },
        },
        {
          headerName: 'Suite #',
          field: 'suite',
          headerTooltip: 'Suite #',
          cellStyle: params => projectlockedRow(params, 'suite', 'left'),
          width: 80,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          resizable: true,
          hide: false,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          suppressColumnsToolPanel: !this.assetList.some(
            i => i.structureProfileId === 3,
          ),
        },
        {
          headerName: 'Tenant',
          field: 'tenant',
          headerTooltip: 'Tenant',
          headerClass: 'analysis-header-left',
          cellStyle: params => projectlockedRow(params, 'tenant', 'left'),
          width: 150,
          wrapText: false,
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          resizable: true,
          hide: false,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          suppressColumnsToolPanel: !this.assetList.some(
            i => i.structureProfileId === 3,
          ),
        },
        {
          headerName: 'Contract',
          field: 'contract',
          headerTooltip: 'Contract',
          sort: 'asc',
          cellStyle: params => projectlockedRow(params, 'contract', 'left'),
          width: 100,
          wrapText: false,
          filter: 'customFilter',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            dropdownName: 'contract',
            dropdownData: this.dropdownInfo,
            name: 'contract',
            width: '350px !important',
          },
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          headerClass: 'analysis-header',
          editable: !this.isArchive,
        },
        {
          headerName: 'Contract Name',
          field: 'contractName',
          headerTooltip: 'Contract Name',
          cellStyle: params => projectlockedRow(params, 'contractName', 'left'),
          width: 150,
          wrapText: false,
          filter: 'customFilter',
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            precision: 2,
            min: 0,
            name: 'contractName',
          },
          suppressSizeToFit: true,
          editable: false,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          sort: 'asc',
          headerTooltip: 'Category Code',
          cellEditor: 'selectEditor',
          filter: 'customFilter',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
            dropdownName: 'category',
            dropdownData: this.dropdownInfo,
            name: 'categoryCode',
            width: '350px !important',
          },
          cellStyle: params => projectlockedRow(params, 'categoryCode', 'left'),
          width: 100,
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          headerClass: 'analysis-header',
          editable: !this.isArchive,
        },
        {
          headerName: 'Category Description',
          field: 'categoryCodeDescription',
          headerTooltip: 'Category Description',
          filter: 'customFilter',
          cellStyle: params =>
            projectlockedRow(params, 'categoryCodeDescription', 'left'),
          width: 150,
          wrapText: false,
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            precision: 2,
            min: 0,
            name: 'categoryCodeDescription',
          },
          suppressSizeToFit: true,
          editable: false,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Asset Class',
          field: 'assetClass',
          headerTooltip: 'Asset Class',
          cellEditor: 'inputCellEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            name: 'asset_Class',
          },
          cellStyle: params => projectlockedRow(params, 'assetClass', 'left'),
          width: 100,
          suppressSizeToFit: true,
          editable: false,
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Life',
          field: 'life',
          headerTooltip: 'Life',
          cellEditor: 'inputCellEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            name: 'life',
          },
          cellStyle: params => projectlockedRow(params, 'life', 'left'),
          width: 100,
          suppressSizeToFit: true,
          editable: false,
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Takeoff Grouping',
          field: 'takeoffGrouping',
          headerTooltip: 'Takeoff Grouping',
          width: 200,
          suppressSizeToFit: true,
          cellEditor: 'autocomplete',
          filter: 'customFilter',
          cellStyle: params =>
            projectlockedRow(params, 'takeoffGrouping', 'left'),
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
            name: 'takeoff_Grouping_Name',
            dropdownURL: `${dropdownAPIs.takeoffGrouping}/`,
          },
          cellRenderer: 'toolTipRenderer',
          hide: true,
          editable: false,
        },
        {
          headerName: 'Group',
          field: 'interiorGroup',
          headerTooltip: 'Group',
          cellEditor: 'inputCellEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
          },
          width: 100,
          filter: 'customFilter',
          headerClass: 'header-left',
          cellStyle: params =>
            projectlockedRow(params, 'interiorGroup', 'left'),
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Additional Description',
          field: 'additionalDescription',
          headerClass: 'header-center',
          cellStyle: params =>
            projectlockedRow(params, 'additionalDescription', 'center'),
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
            placeholder: 'Additional Description',
          },
          width: 150,
          headerTooltip: 'Additional Description',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          filter: 'customFilter',
          editable: !this.isArchive,
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          headerTooltip: 'Takeoff',
          width: 400,
          cellEditor: 'autocomplete',
          cellStyle: params => projectlockedRow(params, 'takeoff', 'left'),
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
            name: 'takeoff_Name',
            dropdownURL: undefined,
            screen: 'Project',
          },
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Calculation',
          field: 'calculation',
          cellEditor: 'calculationEditor',
          cellStyle: params =>
            strikeProjectAnalysisCalculations(params, 'calculation', 'left'),
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
            name: 'calculation',
            dropdownData: this.dropdownInfo.calculation,
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Calculation',
          resizable: true,
          width: 100,
          headerClass: 'header-left',
          editable: !this.isArchive,
          filter: 'customFilter',
        },
        {
          headerName: 'Group Quantity',
          field: 'groupQuantity',
          headerTooltip: 'Group Quantity',
          width: 100,
          filter: 'customFilter',
          cellEditor: 'inputNumberEditor',
          headerClass: 'header-left',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          cellStyle: params =>
            projectlockedRow(params, 'groupQuantity', 'right'),
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Quantity',
          field: 'quantity',
          headerTooltip: 'Quantity',
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          cellStyle: params => projectlockedRow(params, 'quantity', 'right'),
          width: 100,
          suppressSizeToFit: true,
          headerClass: 'header-right',
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Unit',
          field: 'unit',
          headerTooltip: 'Unit',
          cellStyle: params => projectlockedRow(params, 'unit'),
          headerClass: 'header-center',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
            dropdownName: 'unit',
            dropdownData: this.dropdownInfo,
            width: '250px !important',
          },
          width: 100,
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Unit Price',
          field: 'unitCost',
          headerTooltip: 'Unit Price',
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            precision: 2,
            min: 0,
          },
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: params => projectlockedRow(params, 'unitCost', 'right'),
          headerClass: 'header-right',
          width: 120,
          suppressSizeToFit: true,
          filter: 'customFilter',
          editable: !this.isArchive,
        },
        {
          headerName: 'Multiplier',
          field: 'multiplier',
          headerTooltip: 'Multiplier',
          cellStyle: params => projectlockedRow(params, 'multiplier', 'right'),
          width: 70,
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            name: 'multiplier',
            type: 'analysisSheet',
            dataType: 'decimal',
            precision: 3,
            min: 0,
          },
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          headerClass: 'header-right',
          editable: !this.isArchive,
        },
        {
          headerName: 'Total Price',
          field: 'totalPrice',
          headerTooltip: 'Total Price',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: params => projectlockedRow(params, 'totalPrice', 'right'),
          width: 150,
          cellRendererParams: {
            searchType: 'string',
          },
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          headerClass: 'header-right',
        },
        {
          headerName: 'Time Factor',
          field: 'timeFactor',
          headerTooltip: 'Time Factor',
          valueGetter: params => {
            return params.data.timeFactor && params.data.timeFactor !== null
              ? parseFloat(params.data.timeFactor).toFixed(4)
              : params.data.timeFactor
          },
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            precision: 4,
            min: 0,
            fixed: 4,
            isCheck: true,
          },
          cellStyle: params => projectlockedRow(params, 'timeFactor', 'right'),
          width: 80,
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'numberRender',
          headerClass: 'header-right',
          editable: !this.isArchive,
        },
        {
          headerName: 'Location Factor',
          field: 'locationFactor',
          headerTooltip: 'Location Factor',
          valueGetter: params => {
            return params.data.locationFactor &&
              params.data.locationFactor !== null
              ? parseFloat(params.data.locationFactor).toFixed(3)
              : params.data.locationFactor
          },
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            precision: 3,
            min: 0,
            fixed: 3,
            isCheck: true,
          },
          cellStyle: params =>
            projectlockedRow(params, 'locationFactor', 'right'),
          width: 80,
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'numberRender',
          headerClass: 'header-right',
          editable: !this.isArchive,
        },
        {
          headerName: 'Construction Quality Factor',
          field: 'constructionQualityFactor',
          headerTooltip: 'Construction Quality Factor',
          cellStyle: params =>
            projectlockedRow(params, 'constructionQualityFactor'),
          cellEditor: 'factorEditor',
          cellRendererParams: {
            name: 'constructionQualityFactor',
            type: 'AnalysisSheet',
            precision: 2,
            dropdownData: this.dropdownInfo.construction_quality_factor,
          },
          headerClass: 'analysis-header-center',
          width: 100,
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Condition Factor',
          field: 'conditionFactor',
          headerTooltip: 'Condition Factor',
          cellStyle: params => projectlockedRow(params, 'conditionFactor'),
          headerClass: 'analysis-header-center',
          cellEditor: 'factorEditor',
          cellRendererParams: {
            name: 'conditionFactor',
            type: 'AnalysisSheet',
            precision: 2,
            dropdownData: this.dropdownInfo.condition_factor,
          },
          width: 100,
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Soft Cost',
          field: 'softCost',
          headerTooltip: 'Soft Cost',
          width: 100,
          cellRenderer: 'quantityPerCellRenderer',
          cellEditor: 'inputNumberEditor',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'string',
            precision: 2,
            min: 0,
            max: 100,
          },
          suppressSizeToFit: true,
          cellStyle: params => projectlockedRow(params, 'softCost', 'right'),
          filter: 'customFilter',
          headerClass: 'header-right',
          editable: !this.isArchive,
        },
        {
          headerName: 'RCN',
          field: 'rcn',
          headerTooltip: 'RCN',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: params => projectlockedRow(params, 'rcn', 'right'),
          cellRendererParams: {
            searchType: 'string',
          },
          width: 150,
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          headerClass: 'header-right',
        },
        {
          headerName: 'RCNLD',
          field: 'rcnld',
          headerTooltip: 'RCNLD',
          cellStyle: params => projectlockedRow(params, 'rcnld', 'right'),
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: {
            searchType: 'string',
          },
          width: 150,
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          headerClass: 'header-right',
        },
        {
          headerName: 'Avoid Variance',
          field: 'avoidVariance',
          headerTooltip: 'Avoid Variance',
          cellStyle: params => projectlockedRow(params, 'avoidVariance'),
          headerClass: 'analysis-header-center',
          width: 70,
          editable: false,
          cellRenderer: 'checkboxCellRender',
          cellRendererParams: {
            type: 'analysisSheet',
            dataType: 'int',
            isArchive: this.isArchive,
          },
          suppressSizeToFit: true,
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Variance Factor',
          field: 'varianceFactor',
          headerTooltip: 'Variance Factor',
          cellStyle: params => projectlockedRow(params, 'varianceFactor'),
          headerClass: 'analysis-header-center',
          editable: false,
          width: 70,
          filter: 'customFilter',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet', name: 'varianceFactor' },
        },
        {
          headerName: 'Allocated Cost',
          field: 'allocatedCost',
          headerTooltip: 'Allocated Cost',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: params =>
            projectlockedRow(params, 'allocatedCost', 'right'),
          width: 150,
          cellRendererParams: {
            searchType: 'string',
          },
          editable: false,
          filter: 'customFilter',
          suppressSizeToFit: true,
          headerClass: 'header-right',
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          cellStyle: params => projectlockedRow(params, 'action'),
          headerClass: 'analysis-header-center',
          cellRendererParams: {
            screenType: 'AnalysisSheet',
          },
          floatingFilter: false,
          width: 60,
          suppressSizeToFit: true,
          pinned: 'right',
          menuTabs: [],
          suppressColumnsToolPanel: true,
        },
      ]
    },

    getAssetsDetails() {
      this.assetsData = this.assetList
      const isShow = this.assetsData.some(i => i.structureProfileId === 3)
      if (!isShow) {
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'suite',
              hide: true,
            },
            {
              colId: 'tenant',
              hide: true,
            },
          ],
        })
        this.assetsData.sort((a, b) =>
          a.assetNumber > b.assetNumber
            ? 1
            : b.assetNumber > a.assetNumber
              ? -1
              : 0,
        )
      }
    },

    getData(params) {
      params.api.setSideBarVisible(false)
      params.api.openToolPanel('columns')
      params.api.setColumnDefs(this.columnDefs)
      params.api.setRowData(this.data)
      params.api.redrawRows()
      this.height = calculateGridHeight(
        'AcqAnalysisSheetTable',
        false,
        true,
        false,
        true,
      )
      if (this.height) {
        this.height = Number(this.height.split('px')[0]) - 68 + 'px'
      }
      this.getColumnSettings(params)
      this.checkPreference()
    },

    getAnalysisData() {
      this.loader = true
      const url = projectAPIs.project.asset.analysisSheet.list(
        this.$route.params.id,
      )
      instance
        .get(url)
        .then(res => {
          this.data = _.get(res.data, 'result', [])
          let isShow = false
          if (this.data.length > 0) {
            this.data.forEach((element, index) => {
              element.columnId = index + 1
              if (element.isLocked) {
                isShow = true
              }
              if (element.calculation) {
                element.formula = convertCalculationForTemplateAnalysisSheet(
                  element.calculation,
                  element,
                  this.dropdownInfo.calculation,
                )
                if (evaluateQantity(element.formula) < 0) {
                  element.quantity =
                    element.quantity < 0 ? null : element.quantity
                }
              }
              if (element.editedFields) {
                element.editedFields = replaceKeys(
                  JSON.parse(element.editedFields),
                )
              }
            })
            this.gridOptions.api.setRowData(this.data)
            this.gridOptions.columnApi.applyColumnState({
              state: [
                {
                  colId: 'isLocked',
                  hide: !isShow,
                },
              ],
            })
          } else {
            this.data = []
            this.gridOptions.api.setRowData([])
            this.gridOptions.api.redrawRows()
          }
          this.onSetFocusCell()
          this.loader = false
          this.title = 'Loading data...'
        })
        .catch(err => {
          this.loader = false
          this.title = 'Loading data...'
          errorService(err)
        })
    },

    deleteRecord(record) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete this row?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related to selected
              takeoff
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(record)
        },
        onCancel() {},
      })
    },

    deleteTakeOff() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected takeoff ?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related to selected
              takeoff
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() {},
      })
    },

    confirmDelete(record) {
      this.loader = true
      const url = projectAPIs.project.asset.analysisSheet.takeoff(
        this.$route.params.id,
        0,
      )
      const ids = record ? [record.id] : this.selectedRowKeys
      this.loaderDelete = true
      instance
        .delete(url, { data: ids })
        .then(response => {
          showNotification(
            'success',
            'Delete',
            _.get(response.data, 'message', null),
          )
          ids.map(element => {
            const findIndex = this.data.findIndex(val => val.id === element)
            if (findIndex > -1) {
              this.data.splice(findIndex, 1)
            }
          })
          this.selectedRowKeys = []
          this.enableDeleteClone = false
          this.loader = false
          this.getAnalysisData()
          this.$emit('enableExtraButtons', false)
          this.$emit('loadTemplateSideBar')
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    cloneTakeOff(id) {
      const req = id ? [id] : this.selectedRowKeys
      const url = projectAPIs.project.asset.analysisSheet.clone(
        this.$route.params.id,
        0,
      )
      this.loader = true
      instance
        .put(url, req)
        .then(res => {
          this.selectedRowKeys = []
          this.enableDeleteClone = false
          this.getAnalysisData()
          this.$emit('enableExtraButtons', false)
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    unlockRow(record) {
      let ids = [record.id]
      const isPresent = this.selectUnlockRowKeys.find(i => i === record.id)
      if (isPresent) {
        ids = this.selectUnlockRowKeys
      }
      const url = projectAPIs.project.asset.analysisSheet.takeoff(
        this.$route.params.id,
        0,
      )
      this.loader = true
      instance
        .put(url, ids)
        .then(response => {
          showNotification(
            'success',
            'Row unlocked',
            _.get(
              response.data,
              'message',
              `${ids.length > 1 ? 'Rows' : 'Row'} has been unlocked`,
            ),
          )
          this.selectUnlockRowKeys = []
          this.selectedRowKeys = []
          this.getAnalysisData()
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    onModelUpdated() {
      if (this.newlyAddedRecord) {
        const indexOfNewRecord = this.gridOptions.api.rowModel.rowsToDisplay.findIndex(
          val => val.data.id === this.newlyAddedRecord,
        )
        this.gridOptions.api.setFocusedCell(indexOfNewRecord, this.colKey)
        this.gridOptions.api.startEditingCell({
          rowIndex: indexOfNewRecord,
          colKey: this.colKey,
        })
        this.newlyAddedRecord = undefined
        this.colKey = 'takeoff'
      }
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length === 0
      ) {
        this.gridOptions.api.showNoRowsOverlay()
      }
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length > 0
      ) {
        this.gridOptions.api.hideOverlay()
      }
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectUnlockRowKeys = selectedNodes
        .filter(i => i.data.isLocked)
        .map(node => node.data.id)
      this.enableDeleteClone = selectedData.length > 0
      this.$emit('enableExtraButtons', selectedData.length > 0)
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectUnlockRowKeys = selectedNodes
        .filter(i => i.data.isLocked)
        .map(node => node.data.id)
      this.enableDeleteClone = selectedData.length > 0
      this.$emit('enableExtraButtons', selectedData.length > 0)
    },

    onUpdateTakeoff(value, record, key, indexData, takeoff, data) {
      this.isAddTakeoff = false
      const url = projectAPIs.project.asset.analysisSheet.takeoff(
        this.$route.params.id,
        0,
      )
      this.tableState = this.gridOptions.columnApi.getColumnState()
      this.title = 'Please wait while updating analysis sheet...'
      const request = []
      let enabled = true
      let isValid = true
      const isPresent = this.selectedRowKeys.find(i => i === record.id)
      if (!isPresent) {
        this.selectedRowKeys = []
        this.selectedRowKeys.push(record.id)
      }
      this.selectedRowKeys.forEach(element => {
        const takeoff = this.data.find(i => i.id === element)
        let isManuallyAdded = true
        if (takeoff) {
          isManuallyAdded = takeoff.isManuallyAdded
        }
        if (
          !isManuallyAdded &&
          key !== 'interiorGroup' &&
          key !== 'avoidVariance'
        ) {
          const editedFields = record.editedFields
            ? JSON.parse(record.editedFields)
            : []
          const isCheck = editedFields.find(i => i === key)
          if (!isCheck) {
            editedFields.push(key)
          }
          var reqBody = {
            id: element,
            isLocked: true,
            editedFields: JSON.stringify(editedFields),
          }
          if (key === 'avoidVariance') {
            delete reqBody.isLocked
          }
          request.push(reqBody)
        } else {
          request.push({ id: element })
        }
      })
      switch (key) {
        case 'avoidVariance':
          this.takeoffDetails = { ...record }
          request.forEach(element => {
            Object.assign(element, {
              avoidVariance: value,
            })
          })
          break
        case 'contract':
          this.takeoffDetails = { ...record }
          if (value === 'addContract') {
            this.isAddContract = true
            enabled = false
          } else {
            request.forEach(element => {
              Object.assign(element, {
                mContractId: data ? data.id : null,
              })
            })
          }
          break
        case 'categoryCode':
          this.takeoffDetails = { ...record }
          if (value === 'addCategory') {
            this.isAddCategory = true
            enabled = false
          } else {
            request.forEach(element => {
              Object.assign(element, {
                mCategoryCodeId: data ? data.id : null,
                mContractId: data ? data.contractDetailsId : undefined,
              })
            })
          }
          break
        case 'takeoff':
          this.takeoffDetails = { ...record }
          this.isBlurCalled = false
          if (takeoff) {
            if (value === 'new') {
              this.isAddTakeoff = true
              enabled = false
            } else {
              this.isAddTakeoff = false
              request.forEach(element => {
                if (takeoff.id) {
                  Object.assign(element, {
                    mContractId: takeoff.mContractDetailsId,
                    mCategoryCodeId: takeoff.mCategoryCodeId,
                    mUnitId: takeoff.mUnitId,
                    mTakeoffId: takeoff.id,
                    mTakeoffGroupingId: takeoff.takeoffGroupingId,
                    takeoff: takeoff.takeoff,
                    unitCost: takeoff.unitCost,
                    source: takeoff.source,
                    isApplicationMaster: false,
                  })
                } else {
                  Object.assign(element, {
                    mTakeoffId: takeoff.takeoffId,
                    mTakeoffGroupingId: takeoff.takeoffGroupingId,
                    takeoff: takeoff.takeoff,
                    unitCost: takeoff.unitCost,
                    source: takeoff.source,
                    isApplicationMaster: true,
                  })
                }
              })
            }
          } else if (value === 'new') {
            this.takeoffDetails = { ...record }
            this.isAddTakeoff = true
            enabled = false
          } else {
            this.isAddTakeoff = false
            request.forEach(element => {
              Object.assign(element, {
                takeoff: value,
                isApplicationMaster: false,
              })
            })
          }
          break
        case 'calculation':
          request.forEach(element => {
            const takeoff = this.data.find(i => i.id === element.id)
            let isManuallyAdded = true
            if (takeoff) {
              isManuallyAdded = takeoff.isManuallyAdded
            }
            if (!isManuallyAdded) {
              element.editedFields = JSON.parse(element.editedFields)
              const isCheck = element.editedFields.find(i => i === 'quantity')
              if (!isCheck) {
                element.editedFields.push('quantity')
              }
              element.editedFields = JSON.stringify(element.editedFields)
            }
            Object.assign(element, {
              [key]: value,
              quantity:
                evaluateQantity(record.formula) > 0
                  ? evaluateQantity(record.formula)
                  : null,
              isCalculationMatched: true,
            })
          })
          break
        case 'quantity':
          this.takeoffDetails = { ...record }
          validateNumber(value, 'quantity', 'Quantity')
          let isCalculationMatched = false
          if (
            record.formula &&
            value &&
            evaluateQantity(record.formula) === Number(value)
          ) {
            isCalculationMatched = true
          }
          request.forEach(element => {
            Object.assign(element, {
              [key]: value > 0 ? value : null,
              isCalculationMatched: isCalculationMatched,
            })
          })
          break
        case 'constructionQualityFactor':
          request.forEach(element => {
            Object.assign(element, {
              constructionQualityFactorId: data.id,
              [key]: value ? formatValue(value, 2) : value,
            })
          })
          break
        case 'conditionFactor':
          request.forEach(element => {
            Object.assign(element, {
              conditionFactorId: data.id,
              [key]: value ? formatValue(value, 2) : value,
            })
          })
          break
        case 'unit':
          this.takeoffDetails = { ...record }
          request.forEach(element => {
            Object.assign(element, {
              mUnitId: data ? data.id : null,
            })
          })
          break
        case 'multiplier':
          this.takeoffDetails = { ...record }
          isValid = validateNumber(value, 'multiplier', 'Multiplier')
          if (isValid) {
            request.forEach(element => {
              Object.assign(element, {
                [key]: value || null,
              })
            })
          }
          break
        case 'groupQuantity':
          this.takeoffDetails = { ...record }
          isValid = validateNumber(value, 'groupQuantity', 'Group Quantity')
          if (isValid) {
            request.forEach(element => {
              Object.assign(element, {
                [key]: value || null,
              })
            })
          }
          break
        case 'unitCost':
          this.takeoffDetails = { ...record }
          isValid = validateNumber(value, 'unitCost', 'Unit Cost')
          if (isValid) {
            request.forEach(element => {
              Object.assign(element, {
                [key]: value || null,
              })
            })
          }
          break
        case 'timeFactor':
          this.takeoffDetails = { ...record }
          isValid = validateNumber(value, 'timeFactor', 'Time Factor')
          if (isValid) {
            request.forEach(element => {
              Object.assign(element, {
                [key]: value || null,
              })
            })
          }
          break
        case 'locationFactor':
          this.takeoffDetails = { ...record }
          isValid = validateNumber(value, 'locationFactor', 'Location Factor')
          if (isValid) {
            request.forEach(element => {
              Object.assign(element, {
                [key]: value || null,
              })
            })
          }
          break
        case 'softCost':
          this.takeoffDetails = { ...record }
          isValid = validateNumber(value, 'softCost', 'Soft Cost')
          if (isValid) {
            request.forEach(element => {
              Object.assign(element, {
                [key]: value || 0,
              })
            })
          }
          break
        default:
          this.takeoffDetails = { ...record }
          request.forEach(element => {
            Object.assign(element, {
              [key]: value || null,
            })
          })
          break
      }
      if (enabled && isValid) {
        this.onUpdate(value, url, request, key, record)
      } else if (!this.isAddTakeoff) {
        const index = this.data.find(i => i.id === record.id)
        setTimeout(() => {
          this.resetRowData(index)
        }, 100)
      }
    },

    onUpdate(value, url, request, key, record) {
      const currentValue =
        value || value === 0
          ? key === 'avoidVariance'
            ? Boolean(value).toString()
            : value.toString()
          : undefined
      const previousValue = window.previousValue
        ? window.previousValue.toString()
        : window.previousValue === false
          ? 'false'
          : undefined
      if (previousValue !== currentValue) {
        this.isUpdate = true
        this.loader = true
        instance
          .patch(url, request)
          .then(response => {
            this.isBlurCalled = true
            switch (key) {
              case 'avoidVariance':
                this.id = undefined
                this.gridOptions.api.tabToNextCell()
                break
              case 'contract':
              case 'categoryCode':
              case 'takeoff':
              case 'unit':
                this.id = record.id
                this.gridOptions.api.tabToNextCell()
                break
              case 'conditionFactor':
                this.id = record.id
                window.previousValue = record.softCost
                break
              case 'constructionQualityFactor':
                this.id = record.id
                break

              default:
                this.id = record.id // for getting edited row data id after refresh
                break
            }
            this.selectedRowKeys = []
            this.takeoffDetails = null
            this.gridOptions.api.redrawRows()
            this.getAnalysisData()
            this.$emit('enableExtraButtons', false)
          })
          .catch(err => {
            this.loader = false
            const index = this.data.findIndex(i => i.id === record.id)
            this.resetRowData(index)
            errorService(err)
          })
      }
    },

    addNewRecord() {
      const url = projectAPIs.project.asset.analysisSheet.takeoff(
        this.$route.params.id,
        this.assetId,
      )
      this.loader = true
      let newData = [...this.data]
      instance
        .post(url)
        .then(res => {
          this.loader = false
          if (_.get(res.data, 'result', {})) {
            var newRecords = [_.get(res.data, 'result', {})]
            newRecords.map(e => {
              e.isValidTakeoff = true
            })
            newData = newData.concat(newRecords)
            this.data = [...newData]
            const itemsToAdd = addGridRecord(_.get(res.data, 'result', {}))
            this.gridOptions.api.applyTransaction({
              add: itemsToAdd,
            })
            this.data.map((value, index) => {
              value['columnId'] = index + 1
              if (value.calculation) {
                value.formula = convertCalculationForTemplateAnalysisSheet(
                  value.calculation,
                  value,
                  this.dropdownInfo.calculation,
                )
              }
              return value
            })
            // this.gridOptions.api.setRowData(this.data)
            this.gridOptions.api.redrawRows()
            const result = _.get(res.data, 'result', [])
            this.newlyAddedRecord = result.id
          }
        })
        .catch(err => {
          errorService(err)
        })
    },

    getWindowSize(flag) {
      const height = calculateGridHeight('AcqAnalysisSheetTable', true, true)
      if (flag) {
        if (height) {
          this.height = Number(height.split('px')[0]) - 68 + 'px'
        }
      } else {
        if (height) {
          this.height = Number(height.split('px')[0]) + 14 + 'px'
        }
      }
    },

    selectedAsset(value, key) {
      this.assetName = value
      this.assetId = key.key
    },

    onRowDragEnd(e) {
      if (e.overIndex > -1) {
        this.reorder(e)
      } else {
        this.reorder(e)
      }
    },

    onRowDragEnter(e) {
      this.dragIndex = e.overIndex
    },

    reorder(e) {
      let previousId
      let nextId
      let request = null
      let takeoffIds = []
      let sequence
      let isValid = true
      if (e.overIndex > this.dragIndex || e.overIndex === -1) {
        isValid = true
        let index = e.nodes[0].rowIndex
        if (index > 0) {
          previousId = this.data[index - 1].id
          sequence = this.data[index - 1].sequence
        } else {
          index = e.nodes[e.nodes.length - 1].rowIndex
          nextId = this.data[index - 1].id
          sequence = this.data[index - 1].sequence
        }
      } else if (e.overIndex < this.dragIndex) {
        isValid = true
        const index = e.nodes[e.nodes.length - 1].rowIndex
        nextId = this.data[index + 1].id
        sequence = this.data[index + 1].sequence
      } else if (e.overIndex === this.dragIndex) {
        if (this.selectedRowKeys.length > 1) {
          isValid = true
          const index = e.nodes[0].rowIndex
          nextId = this.data[index + 1].id
          sequence = this.data[index + 1].sequence
        } else {
          isValid = false
        }
      }
      if (isValid) {
        this.loader = true
        const isPresent = this.selectedRowKeys.find(i => i === e.node.data.id)
        if (isPresent) {
          takeoffIds = this.selectedRowKeys
        } else {
          takeoffIds.push(e.node.data.id)
        }
        if (previousId || nextId) {
          request = {
            ids: takeoffIds,
            previousId: previousId,
            nextId: nextId,
            sequence: sequence,
          }
          this.reorderTakeoff(request)
        }
      }
    },

    showDrawer() {
      this.visible = !this.visible
      this.gridOptions.api.setSideBarVisible(this.visible)
    },

    checkPreference() {
      const isPresent = this.tableState.find(i => i.colId === 'groupQuantity')
      if (!isPresent) {
        const element = {
          header: 'Group Quantity',
          colId: 'groupQuantity',
          width: 100,
          hide: false,
          pinned: null,
          sort: null,
          sortIndex: null,
          aggFunc: null,
          rowGroup: false,
          rowGroupIndex: null,
          pivot: false,
          pivotIndex: null,
          flex: null,
          display: true,
        }
        const index = this.tableState.findIndex(i => i.colId === 'quantity')
        this.tableState.splice(index, 0, element)
      }
      if (isPresent) {
        const element = this.tableState.find(i => i.colId === 'groupQuantity')
        const index = this.tableState.findIndex(i => i.colId === 'quantity')
        this.tableState.splice(index, 0, element)
      }
      this.gridOptions.columnApi.applyColumnState({
        state: this.tableState,
        applyOrder: true,
      })
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'display',
            hide: true,
          },
          {
            colId: 'checkbox',
            hide: this.isArchive,
          },
          {
            colId: 'action',
            hide: this.isArchive,
          },
          {
            colId: 'allocatedCost',
            pinned: 'right',
          },
        ],
      })
      this.getAssetsDetails()
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSetting()
      }
    },

    gridColumnsChanged(value) {
      if (value && value.source === 'toolPanelUi') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        this.updateColumnSetting()
      }
    },

    onCellValueChanged(event) {
      if (event.colDef.field === 'calculation') {
        if (event.value) {
          this.takeoffDetails = { ...event.data }
          this.takeoffDetails.calculation = event.oldValue
          if (event.oldValue) {
            this.takeoffDetails.formula = convertCalculationForTemplateAnalysisSheet(
              event.oldValue,
              this.takeoffDetails,
              this.dropdownInfo.calculation,
            )
          }
          const calculation = convertCalculationForTemplateAnalysisSheet(
            event.value,
            event.data,
            this.dropdownInfo.calculation,
          )
          event.data.formula = calculation
          event.data.isUpdate = true
          const reg = /^[0-9. ()]+([-+*/()]+[ -+()]?[ 0-9.()]+)*$/
          if (!reg.test(calculation)) {
            showNotification(
              'error',
              'Calculation',
              `Invalid formula, please validate the formula!`,
            )
            this.isCalculationError = true
            this.resetRowData(event.rowIndex)
          } else if (evaluateQantity(event.data['formula']) === 'Error') {
            showNotification(
              'error',
              'Calculation',
              'Invalid formula. Please validate the formula and try again.',
            )
            this.isCalculationError = true
            this.resetRowData(event.rowIndex)
          } else {
            this.onUpdateTakeoff(
              event.value,
              event.data,
              event.colDef.field,
              event.rowIndex,
              null,
              null,
            )
          }
        } else {
          event.data.formula = undefined
          event.data.isUpdate = false
          this.onUpdateTakeoff(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            null,
            null,
          )
        }
      } else if (event.colDef.field === 'constructionQualityFactor') {
        if (event.value) {
          this.takeoffDetails = { ...event.data }
          this.takeoffDetails.constructionQualityFactor = event.oldValue
          const isValid = validateNumber(
            event.value,
            'constructionQualityFactor',
            'Construction Quality Factor',
          )
          if (event.oldValue === Number(event.value)) {
            return // condition to avoid multiple call hiting, even we resetRowData for constructionQualityFactor
          } else if (isValid) {
            let factor = this.dropdownInfo.construction_quality_factor.find(
              i => i.value === event.value,
            )
            if (!factor) {
              factor = {
                id: event.data.constructionQualityFactorId,
              }
            }
            this.onUpdateTakeoff(
              event.value,
              event.data,
              event.colDef.field,
              event.rowIndex,
              null,
              factor,
            )
          } else {
            this.resetRowData(event.rowIndex)
          }
        } else {
          this.takeoffDetails = { ...event.data }
          this.takeoffDetails.constructionQualityFactor = event.oldValue
          this.resetRowData(event.rowIndex)
        }
      } else if (event.colDef.field === 'conditionFactor') {
        if (event.value) {
          this.takeoffDetails = { ...event.data }
          this.takeoffDetails.conditionFactor = event.oldValue
          const isValid = validateNumber(
            event.value,
            'conditionFactor',
            'Condition Factor',
          )
          if (event.oldValue === Number(event.value)) {
            return // condition to avoid multiple call hiting, even we resetRowData for conditionFactor
          }
          if (isValid) {
            window.previousValue = event.oldValue
            let factor = this.dropdownInfo.condition_factor.find(
              i => i.value === event.value,
            )
            if (!factor) {
              factor = {
                id: event.data.conditionFactorId,
              }
            }
            this.onUpdateTakeoff(
              event.value,
              event.data,
              event.colDef.field,
              event.rowIndex,
              null,
              factor,
            )
          } else {
            this.resetRowData(event.rowIndex)
          }
        } else {
          this.takeoffDetails = { ...event.data }
          this.takeoffDetails.conditionFactor = event.oldValue
          this.resetRowData(event.rowIndex)
        }
      } else if (event.colDef.field === 'takeoff' && this.isBlurCalled) {
        if (event.value.length > 200) {
          this.takeoffDetails = { ...event.data }
          this.takeoffDetails.takeoff = event.oldValue
          showNotification(
            'error',
            'Takeoff',
            'Takeoff should consist of 200 characters only!',
          )
          this.resetRowData(event.rowIndex)
        } else {
          this.onUpdateTakeoff(
            event.value,
            event.data,
            event.colDef.field,
            event.rowIndex,
            null,
            null,
          )
        }
      }
      this.isBlurCalled = true
    },

    tabToNextCell(params) {
      const previousCell = params.previousCellPosition
      const nextCellPosition = params.nextCellPosition
      let result = null
      if (nextCellPosition) {
        result = {
          rowIndex: nextCellPosition.rowIndex,
          column: nextCellPosition.column,
          floating: previousCell.floating,
        }
        return result
      }
    },

    newTakeOff(action) {
      this.isAddTakeoff = false
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (action === 'cancel') {
        if (this.takeoffDetails.formula) {
          newData[index].formula = this.takeoffDetails.formula
        }
        newData[index].takeoff = this.takeoffDetails.takeoff
        this.data = [...newData]
        this.gridOptions.api.redrawRows()
        this.isUpdate = true
        this.onSetFocusCell()
      } else {
        this.gridOptions.api.redrawRows()
        this.isUpdate = true
        this.onSetFocusCell()
      }
      this.takeoffDetails = null
    },

    addContract(data, flag) {
      this.isAddContract = flag
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (data) {
        this.gridOptions.api.redrawRows()
        this.onUpdateTakeoff(
          data.contract,
          this.takeoffDetails,
          'contract',
          index,
          null,
          data,
          null,
        )
        this.$root.$emit('addContract', data)
      } else {
        this.resetRowData(index)
        this.isUpdate = true
      }
    },

    addCategory(data, contracts, flag) {
      this.isAddCategory = flag
      const newData = [...this.data]
      const index = newData.findIndex(i => i.id === this.takeoffDetails.id)
      if (data) {
        const category = {
          id: data.id,
          masterId: data.masterId,
          option: `${data.categoryCode} - ${data.description}`,
          value: `${data.categoryCode} - ${data.description}`,
          description: data.description,
          contractDetailsId: data.mContractDetailsId,
        }
        this.gridOptions.api.redrawRows()
        this.onUpdateTakeoff(
          data.categoryCode,
          this.takeoffDetails,
          'categoryCode',
          index,
          null,
          category,
          null,
        )
        this.$root.$emit('addCategoryCode', category, contracts)
      } else {
        this.resetRowData(index)
        this.isUpdate = true
      }
    },

    onSetFocusCell() {
      if (this.isUpdate) {
        const focusedCell = this.gridOptions.api.getFocusedCell()
        let rowIndex = focusedCell.rowIndex
        const colId = focusedCell.column.colId
        if (this.id) {
          rowIndex = this.data.findIndex(val => val.id === this.id)
        }
        if (focusedCell && rowIndex !== this.data.length - 1) {
          this.gridOptions.api.setFocusedCell(rowIndex, colId)
          this.gridOptions.api.startEditingCell({
            rowIndex: rowIndex,
            colKey: colId,
          })
        }
      }
      this.isUpdate = false
    },

    reorderTakeoff(request) {
      instance
        .put(
          projectAPIs.project.asset.analysisSheet.reorder(
            this.$route.params.id,
          ),
          request,
        )
        .then(response => {
          this.loader = false
          this.selectedRowKeys = []
          this.getAnalysisData()
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    sortChanged() {
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'display',
            hide: true,
          },
        ],
      })
      this.updateColumnSetting()
    },

    exportSheet() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    resetRowData(index) {
      const newData = [...this.data]
      if (newData[index]) {
        if (this.takeoffDetails.formula) {
          newData[index].formula = this.takeoffDetails.formula
        }
      }
      var quantityValue = newData[index].quantity
      newData[index] = this.takeoffDetails
      // code for remain same quantity as inserted
      newData[index].quantity = quantityValue
      this.data = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        this.takeoffDetails,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(
          focusedCell.rowIndex,
          focusedCell.column.colId,
        )
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: focusedCell.column.colId,
        })
      }
      this.takeoffDetails = null
      this.isBlurCalled = true
    },

    messageRecieved(message) {
      const data = JSON.parse(message.message)
      if (
        data.EventType === socketEvents.updateVarianceFactor &&
        data.Result.Project_Details_Id === parseInt(this.$route.params.id)
      ) {
        this.getAnalysisData()
      } else if (data.EventType === socketEvents.projectSidebarUpdated) {
        this.$root.$emit('projectSideBarUpdated', message)
      } else if (data.EventType === socketEvents.analysisSheetUpdated) {
        this.getAnalysisData()
      } else if (data.EventType === socketEvents.fileExported) {
        this.$root.$emit('message-received', message)
      } else if (data.EventType === socketEvents.error) {
        this.loader = false
        showNotification(
          'error',
          'Socket',
          _.get(data, 'Result.Message', null),
        )
      } else if (data.EventType === socketEvents.takeoffReconcile) {
        this.$root.$emit('popupUpdation', false, true, null)
        if (data.Status === 'ERROR') {
          showNotification(
            'error',
            'Reconcile Analysis Sheet',
            _.get(data.Result, 'Message', ''),
          )
        } else {
          if (this.activeKey === '1') {
            this.getAnalysisData()
          }
        }
      }
    },

    getColumnSettings(params) {
      const columnDetails = this.columnSettings.find(
        i => i.screenId === 7 && i.tableName === 'AnalysisSheet',
      )
      if (columnDetails && columnDetails.columnDetails) {
        this.tableState = JSON.parse(columnDetails.columnDetails)
      } else if (this.templateInfo && this.projectData.columnsDetails) {
        this.tableState = JSON.parse(this.projectData.columnsDetails)
      } else {
        this.tableState = this.gridOptions.columnApi.getColumnState()
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: 7,
        tableName: tableName.project.analysisSheet,
        columnDetails: JSON.stringify(tableState),
      }
      if (!this.isArchive) {
        this.$emit('updateColumnSettings', request)
      }
    },

    reconcileSheet() {
      this.$root.$emit('popupUpdation', true, true, 'Please wait...')
      const url = projectAPIs.project.asset.analysisSheet.reconcile(
        this.$route.params.id,
      )
      instance
        .post(url)
        .then(response => {
          this.getAssetsDetails()
          if (response.data.message === 'Success') {
            this.$root.$emit('popupUpdation', false, true, null)
            this.getAnalysisData()
          }
        })
        .catch(err => {
          this.$root.$emit('popupUpdation', false, true, null)
          errorService(err)
        })
    },
  },
}
